import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Notice } from '../models/notice';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../../../utils/app-settings';

@Injectable()
export class NoticesService {

  constructor(private http: HttpClient) { }

  getNotices(): Observable<Array<Notice>> {
    return this.http.get<Array<Notice>>(AppSettings.apiUrl + "notices")
  }

  getNoticeById(id: number): Observable<Notice> {
    return this.http.get<Notice>(AppSettings.apiUrl + "notices/" + id);
  }
}
